import { z } from 'zod';
import { TIME_STRICT_REGEX } from '@/utils/timeConversion';


const adjustMarkBaseSchema = z.object({
  newTime: z.string()
    .regex(TIME_STRICT_REGEX, 'attendance:marksReport.adjust.validation.invalidTimeFormat')
    .optional()
    .or(z.literal(''))
    .transform((value) => (value ? value : undefined)),
  newEventId: z.string()
    .optional()
    .or(z.literal(''))
    .transform((value) => (value ? value : undefined)),
  comment: z.string()
    .trim()
    .min(1, 'attendance:marksReport.adjust.validation.commentRequired')
    .max(100, 'attendance:marksReport.adjust.validation.commentMaxLength'),
});

export const adjustMarkFormSchema = adjustMarkBaseSchema.refine(
  (data) => !!data.newTime || !!data.newEventId,
  {
    message: 'attendance:marksReport.adjust.validation.atLeastOneRequired',
    path: ['newTime'],
  },
);

export type AdjustMarkFormValues = z.infer<typeof adjustMarkFormSchema>;
